import $ from 'jquery';
import newsService from 'framework/services/newsService';
import NewsItem from './NewsItem/index.js';
import ClubStore from 'framework/stores/ClubStore';
import moment from 'moment';
import selectorConfig from './config.js';

var NEWS_SERVICE_LIMIT = 6;
var NEWS_LIMIT = 3;
var initialized = false;

//detect hidden elements that only appear on author that don't depend on an event.
var notAuthor = $('nav').find('lt-author').length === 0;

function getNews(clubId) {
	var newsQuery = {
		clubId: clubId,
		limit: NEWS_SERVICE_LIMIT
	};
	// call news service to get the images
	return newsService.getNews(newsQuery);
}

function drawNewsItem(newsItem){
	let date = moment();
	let displayStart = false;
	let displayEnd = false;
	if(newsItem.startDate) {
		let startDate = moment(newsItem.startDate, moment.ISO_8601);
		if(date.isAfter(startDate) || date.isSame(startDate)) {
			displayStart = true;
		}
	}else{
		displayStart = true;
	}

	if(newsItem.endDate) {
		let endDate = moment(newsItem.endDate, moment.ISO_8601);
		if(date.isBefore(endDate) || date.isSame(endDate)) {
			displayEnd = true;
		}
	}else{
		displayEnd = true;
	}

	if(displayStart && displayEnd) {
		let news = new NewsItem(newsItem);
		return news.render();
	}else{
		return '';
	}
}

function updateNewsContainer(newsContainer, clubId) {
	let tempNewsContainer = '';
	let newsCount = 0;
	getNews(clubId).then((data)=> {
		if(data.length) {
			_.forEach(data, (n)=> {
				if(newsCount < NEWS_LIMIT) {
					let newsItem = drawNewsItem(n);
					tempNewsContainer = tempNewsContainer + newsItem;
					if(newsItem.length) {
						newsCount++;
					}
				}
			});
			if(tempNewsContainer.length) {
				if(newsCount > 2) {
					tempNewsContainer = '<div class="card-deck card-deck-three-up small">' + tempNewsContainer;
				}else{
					tempNewsContainer = '<div class="card-deck small">' + tempNewsContainer;
				}
				tempNewsContainer = tempNewsContainer + '</div>';
				// clear out the news container to display news items
				$(selectorConfig.newsContainer).html(tempNewsContainer);
			}
		}
		// display the section if there is news or not
		$(selectorConfig.newsContainer).removeClass('hide');
	}, (xhr)=> {
		// display no news
		$(selectorConfig.newsContainer).removeClass('hide');
	});

}

if($(selectorConfig.newsContainer).length) {
	ClubStore.listen((club) => {
		if(!initialized && club.id) {
			updateNewsContainer($(selectorConfig.newsContainer), club.id);
			initialized = true;
		}
	});
}
